import { render, staticRenderFns } from "./proformaDetay.vue?vue&type=template&id=f736b692&scoped=true&"
import script from "./proformaDetay.vue?vue&type=script&lang=js&"
export * from "./proformaDetay.vue?vue&type=script&lang=js&"
import style0 from "./proformaDetay.vue?vue&type=style&index=0&id=f736b692&lang=scss&scoped=true&"
import style1 from "./proformaDetay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f736b692",
  null
  
)

export default component.exports